import axios from "axios";
import { API_BASE } from "../../config/env";
export const FETCH_DELETEAPPLICATION_FULFILLED = "FETCH_DELETEAPPLICATION_FULFILLED";
export const FETCH_DELETEAPPLICATION_REJECTED = "FETCH_DELETEAPPLICATION_REJECTED";
export const FETCH_DELETEAPPLICATION_PENDING = "FETCH_DELETEAPPLICATION_PENDING";
export const RESET = "RESET"

export function deleteApplication(id) {
    const token = localStorage.getItem("accessToken")
    return (dispatch) => {
        dispatch({
            type: "FETCH_DELETEAPPLICATION",
            payload: axios({
                method: "delete",
                url: `${API_BASE}/api/v3/second-opinion/delete-application?applicationId=${id}`,
                headers: {
                    "Authorization": "Bearer " + token,
                    "Accept-Language": "tr-tr",
                    "Client-Id": localStorage.getItem("One-Id"),
                    "One-Id": localStorage.getItem("Client-Id"),
                    "Content-Type": "application/json",
                    "ngrok-skip-browser-warning" : "69920"
                },
            }).then((result) => result.data),
        });
    };
}

export function resetDeleteApplication() {
    return (dispatch) => {
        dispatch({
            type: "RESET",
        });
    };
  }


